













































































































































































import _ from 'lodash';
import { editFactory } from '@/main/pages';

import { NAME, VOJ, ALTERNATIVY_VOJ, TABS, TAB_NAMES } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	data() {
		return {
			dependencies: [VOJ],
			tabNames: TAB_NAMES,
		};
	},
	created() {
		if (!this.mainCollapse.length) {
			this.mainCollapse = [VOJ, ALTERNATIVY_VOJ];
		}
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.HlavniUdaje)) { tabItems.push(TAB_NAMES.HLAVNIUDAJE); }
			if (this.hasTabAccess(NAME, TABS.Tripod)) { tabItems.push(TAB_NAMES.TRIPOD); }
			if (this.hasTabAccess(NAME, TABS.eGUI)) { tabItems.push(TAB_NAMES.EGUI); }
			if (this.hasTabAccess(NAME, TABS.ABC_CATEGORY)) { tabItems.push(TAB_NAMES.ABC_CATEGORY); }
			if (this.hasTabAccess(NAME, TABS.FMS_CATEGORY)) { tabItems.push(TAB_NAMES.FMS_CATEGORY); }
			if (this.hasTabAccess(NAME, TABS.AudaNext)) tabItems.push(TAB_NAMES.AUDANEXT);
			if (this.hasTabAccess(NAME, TABS.EDFS)) tabItems.push(TAB_NAMES.EDFS);
			return _.pick(TABS, tabItems);
		},
	},
	watch: {
		'dependentTables.Voj.rows': {
			handler(rows) {
				rows[0] && this.vojChangeCurrentRow(rows[0].cells);
				(this.$refs.Voj as any).refreshLayout();
			},
		},
		showByVoj: {
			handler(e) {
				if (e) {
					this.refreshTable(VOJ);
				}
			},
		},
	},
	methods: {
		updateAudatexPassword() {
			this.AudatexPassw = btoa(this.AudatexPassw!);
		},
		loadedData() {
			this.fetchTableSchemas([ALTERNATIVY_VOJ]);
		},
		vojChangeCurrentRow(rowId: any) {
			const column = this.dependentTables.Voj.columns.find((item) => item.columnName === 'OJKONTXT_ID');
			this.currentRowVoj = rowId[(column && column.columnId) || 0];
			this.refreshTable(ALTERNATIVY_VOJ);
		},
	},
});
